import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getCourseMultiTaskStatus = (payload) =>
  httpClient.get(apis.getCourseMultiTaskStatus(payload));
